import round from 'lodash/round';

import type {InsightsSeriesTree} from './types';
import {NUMERIC_DATA_PRECISION} from './constants';

export function roundInsightsValue(value: number) {
  return round(value, NUMERIC_DATA_PRECISION);
}

/**
 * Check if insights series data is a leaf. `all` is for event queries, `value` is for profile queries.
 * query-api returns `null` for constant formulas not associated with any show clauses.
 */
export function getValueIfLeaf(series: InsightsSeriesTree): number | null {
  for (const leafKey of [`all`, `value`, `null`]) {
    if (leafKey in series && typeof series[leafKey] === `number`) {
      return roundInsightsValue(series[leafKey] as number);
    }
  }

  return null;
}
